'use client'

import { memo } from 'react'
import { formatPrice } from '~/utils/format'
import StepperControl from '~/components/ui/stepper-control'

interface RoomFooterProps {
  price: number
  available: number
  quantity: number
  onDecrease: () => void
  onIncrease: () => void
  onQuantityChange: (value: number) => void
  t: (key: string) => string
}
const MAX_QUANTITY = 10

function RoomFooter({
  price,
  available,
  quantity,
  onDecrease,
  onIncrease,
  onQuantityChange,
  t,
}: RoomFooterProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="flex flex-col gap-1">
        <div className="text-sm font-medium leading-4 text-[#2D2E32]">{formatPrice(price)}</div>
        {available <= MAX_QUANTITY && (
          <span className="text-[12px] font-light leading-4 text-[#E02424]">
            {t('roomType.onlyLeft')} {available} {t('booking.rooms')}
          </span>
        )}
      </div>
      <StepperControl
        value={quantity}
        min={0}
        max={available}
        onDecrement={onDecrease}
        onIncrement={onIncrease}
        onChange={onQuantityChange}
      />
    </div>
  )
}

function arePropsEqual(prevProps: RoomFooterProps, nextProps: RoomFooterProps) {
  return (
    prevProps.price === nextProps.price &&
    prevProps.available === nextProps.available &&
    prevProps.quantity === nextProps.quantity
  )
}

export default memo(RoomFooter, arePropsEqual)
